<div class="wrapper-on-all site-tree">
  <div class="form-group row">
    @if (loading) {
      <div class="main-container">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    }

    @if (!loading) {
      <div class="tree">
        <div class="site-tree-container">
          <mat-tree
            [dataSource]="dataSource"
            [treeControl]="treeControl"
            cdkDropList
            (cdkDropListDropped)="drop($event)">
            <mat-tree-node
              *matTreeNodeDef="let node"
              matTreeNodeToggle
              matTreeNodePadding
              cdkDrag
              [cdkDragDisabled]="!node.entity.operations.canMove"
              [cdkDragData]="node"
              (mouseenter)="dragHover(node)"
              (mouseleave)="dragHoverEnd(node)"
              (cdkDragStarted)="dragStart()"
              (cdkDragReleased)="dragEnd()"
              (click)="onClick(node)"
              [ngClass]="{
                active: activeNode === node,
                hover: hoveredNode === node && activeNode !== node,
              }">
              <app-form-field-site-tree-toolbar
                [hasChildren]="false"
                [expanded]="treeControl.isExpanded(node)"
                [node]="node"
                [activeNode]="activeNode"
                [hoveredNode]="hoveredNode"
                (onNodeSelected)="onNodeSelected(node)"
                (onEdit)="onEditClicked(node)"
                (onDelete)="onDeleteClicked(node)"
                (onNew)="onNewClicked(node)"></app-form-field-site-tree-toolbar>
            </mat-tree-node>
            <mat-tree-node
              *matTreeNodeDef="let node; when: hasChild"
              matTreeNodePadding
              cdkDrag
              [cdkDragData]="node"
              [cdkDragDisabled]="!node.entity.operations.canMove"
              (mouseenter)="dragHover(node)"
              (mouseleave)="dragHoverEnd(node)"
              (cdkDragStarted)="dragStart()"
              (cdkDragReleased)="dragEnd()"
              (click)="onClick(node)"
              [ngClass]="{
                active: activeNode === node,
                hover: hoveredNode === node && activeNode !== node,
              }">
              <app-form-field-site-tree-toolbar
                [hasChildren]="true"
                [node]="node"
                [activeNode]="activeNode"
                [hoveredNode]="hoveredNode"
                (onNodeSelected)="onNodeSelected(node)"
                (onEdit)="onEditClicked(node)"
                (onDelete)="onDeleteClicked(node)"
                (onNew)="onNewClicked(node)"></app-form-field-site-tree-toolbar>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    }

    @if (activeNode || creatingNew) {
      <mat-card class="details-page">
        @if (activeNodeLoading) {
          <div class="loading-spinner">
            <mat-spinner [diameter]="24"></mat-spinner>
          </div>
        }
        @if (!activeNodeLoading) {
          <div class="active-node-title">
            <h2>{{ activeNode ? activeNode.entity.title : 'Create new' }}</h2>
            <div class="buttons">
              @if (!isEdit) {
                <button mat-icon-button color="accent" (click)="editNode(activeNode)">
                  <mat-icon class="mat-icon-rtl-mirror"> edit </mat-icon>
                </button>
              }
              <button mat-icon-button color="accent" (click)="onFlip(activeNode)">
                <img src="assets/icon/flip-icon.svg" class="flip-icon" />
              </button>
            </div>
          </div>
        }
        @if (!activeNodeLoading) {
          @for (field of showContent ? contentFields : settingsFields; track field) {
            <span>
              <div class="info-container">
                @if (!field.noLabel) {
                  <span class="info-label"> {{ field.label }}: </span>
                }
                <app-form-field
                  [type]="field.type"
                  [data]="formGroupSubset.getRawValue()[field.name]"
                  [rowData]="formGroupSubset.getRawValue()"
                  [fieldConfig]="field"
                  [editMode]="isEdit"
                  [formGroup]="formGroupSubset"></app-form-field>
              </div>
            </span>
          }
        }
        @if (isEdit && !activeNodeLoading) {
          <div class="edit-buttons">
            @if (!creatingNew) {
              <button mat-raised-button color="primary" (click)="saveNode()">Update</button>
            }
            @if (creatingNew) {
              <button mat-raised-button color="primary" (click)="createNewNode()">Create</button>
            }
            <button mat-button color="accent" (click)="cancelUpdating()">Cancel</button>
          </div>
        }
      </mat-card>
    }
  </div>
</div>
